module.exports = __webpack_public_path__ + "static/media/segoe-ui-semibold.e6df1498.ttf";